import cx from "classnames";
import React from "react";

import { Btn, BtnType } from "@/mk2/components/Btn";
import { Modal } from "@/mk2/components/Modal";
import { Panel } from "@/mk2/components/Panel";
import useEventCallback from "@/mk2/hooks/useEventCallback";
import {
    CONVERT_TO_DISCUSSION_MODAL_DESCRIPTION,
    CONVERT_TO_DISCUSSION_MODAL_DESCRIPTION2,
    CONVERT_TO_DISCUSSION_MODAL_DESCRIPTION3,
    CONVERT_TO_DISCUSSION_MODAL_SAVE_AS_FORUM_THREAD,
    CONVERT_TO_DISCUSSION_MODAL_SAVE_AS_PHOTOBLOG_SHORT_MESSAGE,
    CONVERT_TO_DISCUSSION_MODAL_SAVE_BOTH,
    CONVERT_TO_DISCUSSION_MODAL_TITLE,
} from "@/mk/autogenerated/translation";

import styles from "./ConvertToDiscussionModal.mscss";

interface OwnProps {
    className?: string;
    show: boolean;

    onSaveAsForumThread();
    onSaveAsPhotoblogShortMessage();
    onSaveBoth();
}

type Props = OwnProps;

const ConvertToDiscussionModal = React.memo<Props>(
    ({ className, show, onSaveAsForumThread, onSaveAsPhotoblogShortMessage, onSaveBoth }) => {
        const handleSaveAsForumThread = useEventCallback(() => {
            onSaveAsForumThread();
        }, [onSaveAsForumThread]);

        const handleSaveAsPhotoblogShortMessage = useEventCallback(() => {
            onSaveAsPhotoblogShortMessage();
        }, [onSaveAsPhotoblogShortMessage]);

        const handleSaveBoth = useEventCallback(() => {
            onSaveBoth();
        }, [onSaveBoth]);

        return (
            <Modal show={show} className={cx(styles.ConvertToDiscussionModal, className)}>
                <div className={styles.ConvertToDiscussionModal__container}>
                    <Panel className={styles.ConvertToDiscussionModal__panel}>
                        <div className={styles.ConvertToDiscussionModal__title}>
                            <h2>{CONVERT_TO_DISCUSSION_MODAL_TITLE}</h2>
                        </div>

                        <p className={styles.ConvertToDiscussionModal__description}>
                            {CONVERT_TO_DISCUSSION_MODAL_DESCRIPTION}
                            <br />
                            {CONVERT_TO_DISCUSSION_MODAL_DESCRIPTION2}
                            <br />
                            {CONVERT_TO_DISCUSSION_MODAL_DESCRIPTION3}
                        </p>

                        <div className={styles.ConvertToDiscussionModal__actions}>
                            <Btn
                                className={styles.ConvertToDiscussionModal__button}
                                type={BtnType.Blue}
                                onClick={handleSaveAsForumThread}
                                label={CONVERT_TO_DISCUSSION_MODAL_SAVE_AS_FORUM_THREAD}
                            />
                            <Btn
                                className={styles.ConvertToDiscussionModal__button}
                                type={BtnType.BlueOutline}
                                onClick={handleSaveBoth}
                                label={CONVERT_TO_DISCUSSION_MODAL_SAVE_BOTH}
                            />
                            <Btn
                                className={styles.ConvertToDiscussionModal__button}
                                type={BtnType.BlueOutline}
                                onClick={handleSaveAsPhotoblogShortMessage}
                                label={CONVERT_TO_DISCUSSION_MODAL_SAVE_AS_PHOTOBLOG_SHORT_MESSAGE}
                            />
                        </div>
                    </Panel>
                </div>
            </Modal>
        );
    },
);

ConvertToDiscussionModal.displayName = "ConvertToDiscussionModal";

export default ConvertToDiscussionModal;
